import { render, staticRenderFns } from "./BaseLinkToDoc.vue?vue&type=template&id=8b56c63c"
import script from "./BaseLinkToDoc.vue?vue&type=script&lang=js"
export * from "./BaseLinkToDoc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports